var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartOutlinedRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7617 17.5234L9.76098 17.5228C7.45059 15.4277 5.57345 13.7246 4.26789 12.1284C2.96807 10.5392 2.28711 9.11718 2.28711 7.59302C2.28711 5.1177 4.22512 3.17969 6.70044 3.17969C8.10345 3.17969 9.45783 3.83526 10.3398 4.87092L10.7204 5.31796L11.1011 4.87092C11.9831 3.83526 13.3374 3.17969 14.7404 3.17969C17.2158 3.17969 19.1538 5.1177 19.1538 7.59302C19.1538 9.11719 18.4728 10.5393 17.1729 12.1296C15.8688 13.7251 13.9946 15.4282 11.688 17.5244L11.6806 17.5311L11.6795 17.5321L10.7217 18.3974L9.7617 17.5234Z",
    stroke: "#FF0431"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartOutlinedRed);
export default __webpack_public_path__ + "static/media/heart-outlined-red.395b3185.svg";
export { ForwardRef as ReactComponent };